(function() {
'use strict';

const TR = angular.module('TR');

/*
    CONFIGURATION
    -------------
    Config is defined in the maxParagraphs scope variable
    Use EITHER a number :: which defines number of paragraphs to show across all screen sizes
    OR object map with properties sm,md and lg with corresponding values;
    eg { sm : 1 } to only display 1 paragraph on small screens, will display all on md and lg screens
    eg { sm : 1, md : 1 } to display 1 paragraph on small & medium screens...

    screen size breakpoints defined in show-hide-text.less
*/

TR.directive('showHideText', function() {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            text: '=',
            maxParagraphs: '&',
            showMoreText: '@',
            showLessText: '@'
        },
        templateUrl: 'partials/home/directivetemplate?type=ShowHideText',
        link(scope, element) {
            let content = '';
            let activeClasses = ['hidden-sm', 'hidden-md', 'hidden-lg'];

            scope.requiresCropping = false;
            scope.contentIsHidden = true;

            const maxParagraphs = scope.maxParagraphs();
            if (maxParagraphs) {
                scope.requiresCropping = true;
            }

            if (scope.requiresCropping && angular.isObject(maxParagraphs)) {
                const showHideClass = ['hidden-sm', 'hidden-md', 'hidden-lg'];
                for (const key in maxParagraphs) {
                    showHideClass.splice(showHideClass.indexOf(`hidden-${key}`), 1);
                }
                scope.showHideClass = showHideClass.join(' ');
            }

            scope.$watch('text', t => {
                if (!t) { return; }

                // This code has been added for when the descriptions are translated.
                document.querySelector('[ng-bind-html="htmlContent"]');
                tidySpanText();

                content = $('<span/>').html(scope.text);
                determineHiddenText();
            });

            scope.toggleHiddenContent = function(e) {
                e.preventDefault();
                scope.contentIsHidden = !scope.contentIsHidden;
                element.find(`.${activeClasses.join(' .')}`).toggleClass('visible');
            };

            function tidySpanText() {
                setTimeout(() => {
                    let sp = document.querySelectorAll('span[class*="hidden-"]');
                    if (sp[0]) {
                        let children = sp[0].children;
                        for (let i = 0; i < children.length; i++) {
                            children[i].classList.add(sp[0].classList.value);
                        }
                    }
                }, 100);
            }

            function determineHiddenText() {
                scope.htmlContent = '';
                content.children().each((i, el) => {
                    if (maxParagraphs) {
                        if (angular.isNumber(maxParagraphs)) {
                            if (i >= maxParagraphs) {
                                el.classList.add(activeClasses.toString().split(',').join(' '));
                            }
                        } else if (angular.isObject(maxParagraphs)) {
                                activeClasses = [];
                                for (const key in maxParagraphs) {
                                    if (i >= maxParagraphs[key]) {
                                        el.classList.add(`hidden-${key}`);
                                        activeClasses.push(`hidden-${key}`);
                                    }
                                }
                        }
                    }

                    scope.htmlContent += (el.outerHTML || el.textContent);
                });
            }
        }
    };
});
})();
